// ----------------------------------------------------------------------

export const imageClasses = {
  root: 'tpf__image__root',
  wrapper: 'tpf__image__wrapper',
  overlay: 'tpf__image__overlay',
};
